import { IResultScore } from '../resources/istatement/result';

export interface ScoreParams extends Partial<IResultScore> {
	[key: string]: any;
}

export class Score {
	scaled?: number;
	raw?: number;
	min?: number;
	max?: number;

	constructor(cfg: ScoreParams = {}) {
		this.init(cfg);
	}

	init(cfg: ScoreParams = {}): void {
		const { scaled, raw, min, max } = cfg;
		this.scaled = scaled;
		this.raw = raw;
		this.min = min;
		this.max = max;
	}

	asVersion(version: string = '1.0.6'): IResultScore {
		const { scaled, raw, min, max } = this;
		const result: IResultScore = {
			scaled: scaled || 0,
			raw,
			min,
			max
		};

		return result;
	}

	static fromJSON(scoreJSON: string): Score {
		const _score = JSON.parse(scoreJSON);

		return new Score(_score);
	}
}
